import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { MapCableDataPoint, Alarm, CableVessel } from '@/server/MakeSenseApp-backend'

export const usePopupStore = defineStore('popup', () => {
  const isPopupActive = ref<boolean>(false)

  const showCabel = ref<boolean>(false)
  const easting = ref<number>(0)
  const northing = ref<number>(0)

  const kp = ref<number>(0)
  const doB = ref<number>(0)
  const dts = ref<number>(0)
  const das = ref<number>(0)
  const alarms = ref<Alarm[]>([])

  const vesselData = ref<CableVessel | undefined>(undefined)
  const showVessel = ref<boolean>(false)

  const showCabelData = (
    newCableDataPoint: MapCableDataPoint,
    eastingPos?: number,
    northingPos?: number
  ) => {
    easting.value = eastingPos ?? newCableDataPoint.coordinate?.easting!
    northing.value = northingPos ?? newCableDataPoint.coordinate?.northing!
    kp.value = newCableDataPoint.kp!
    doB.value = newCableDataPoint.doB!
    dts.value = newCableDataPoint.dts!
    das.value = newCableDataPoint.das!
    alarms.value = newCableDataPoint.hasAlarms ? newCableDataPoint.alarms! : []

    showCabel.value = true
    showVessel.value = false

    isPopupActive.value = true
  }

  const isActive = computed(() => isPopupActive.value)

  const closePopup = () => {
    isPopupActive.value = false
    showCabel.value = false
    showVessel.value = false
  }

  function showVesselData(vessel: CableVessel, eastingPos?: number, northingPos?: number): void {
    vesselData.value = vessel

    easting.value = eastingPos ?? vesselData.value.easting!
    northing.value = northingPos ?? vesselData.value.northing!

    showVessel.value = true
    showCabel.value = false

    isPopupActive.value = true
  }

  return {
    closePopup,
    showCabelData: showCabelData,
    showVesselData: showVesselData,
    showVessel,
    vesselData: vesselData,
    showCabel,
    isPopupActive,
    easting,
    northing,
    kp,
    doB,
    dts,
    das,
    alarms,
    isActive
  }
})
